import * as ApprovalActions from '../actions/approval.action'
import { IApprovalItem } from '../../shared/interfaces/approval.interface'
import { IQuery } from '../../shared/interfaces/api-query.interface'

interface IApprovalState {
  list: Array<any>
  query: IQuery
  selected: IApprovalItem | null
}

const initialState: IApprovalState = {
  /* eslint-disable camelcase */
  list: [],
  query: {
    page: 1,
    limit: 10,
    q: '!approved',
    order_by: '',
  },
  selected: null,
}

const reducer = (state = initialState, action: { type: string; payload: any }) => {
  const { type, payload } = action

  switch (type) {
    case ApprovalActions.APPROVAL_FETCH_APPLICATIONS:
      return {
        ...state,
        query: payload,
      }

    case ApprovalActions.APPROVAL_FETCH_APPLICATIONS_SUCCESS:
      return {
        ...state,
        list: payload,
      }

    case ApprovalActions.APPROVAL_FETCH_APPLICATIONS_ERROR:
      return {
        ...state,
      }

    case ApprovalActions.APPROVAL_FETCH_APPLICATION:
      return {
        ...state,
        query: payload,
      }

    case ApprovalActions.APPROVAL_FETCH_APPLICATION_SUCCESS:
      return {
        ...state,
        selected: payload,
      }

    case ApprovalActions.APPROVAL_FETCH_APPLICATION_ERROR:
      return {
        ...state,
      }

    default:
      return state
  }
}

export default reducer
